import useToggle from '../hooks/useToggle';
import React, {useCallback, useEffect, useState} from 'react';
import {
  canSubmitW9,
  createW9Form,
  submitW9Form,
} from '../../pages/taxforms/w9/w9functions';
import {TickIcon} from '../../../icons/Icons';
import Modal from '../Modal';
import RenderW9Form from '../../pages/taxforms/w9/RenderW9Form';
import {FiArrowLeft} from 'react-icons/fi';
import {RenderW8Form} from '../../pages/taxforms/w8-ben/W8BENForm';
import {post} from '../../../api';
import dayjs from '../../../mydayjs';

function canSubmitW8(data){
  return data.name && data.country && data.address_1 && data.address_2 && data.tax_identification_number && data.citizenship_country && data.signature

}
export default function W9FormInput({value, label,w9_year, onChange}){
  const [formType, setFormType] = useState(null)
  const [visible, toggle] = useToggle()
  useEffect(() => {
    setData(value?.data || {})
  }, [value?.data]);
  const [data, setData] = useState({})
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null)
  const canSubmit = formType === "w9" ? canSubmitW9(data) : canSubmitW8(data)
  const onSubmit = useCallback((e)=>{
    if(e){
      e.preventDefault();
      e.stopPropagation();
    }
    setLoading(true)
    if(formType === "w8"){
      if(result){
        post('/legal/w8/submit',{file_id:result.file_id})
        .then(()=>{
          setLoading(false)
          onChange({
            target:{
              value: result
            }
          })
          toggle()
        })
      }else {
        setResult(null)
        post('/legal/w8',{
          data:{
            ...data,
            w9_year,
            today:dayjs().format('MM-DD-YYYY'),
          }
        }).then((data) => {
          setLoading(false)
          setResult(data)
        })
      }
    }else{
      if(result){
        submitW9Form(result.file_id).then(()=>{
          setLoading(false)
          onChange({
            target:{
              value: result
            }
          })
          toggle()
        })
      }else {
        setResult(null)
        createW9Form({
          ...data,
          w9_year,
        }).then((data) => {
          setLoading(false)
          setResult(data)
        })
      }
    }
  },[data, formType, result])

  return <>
    <div className={'list-group mt-1'}>
      <button onClick={toggle} type={"button"} className="d-flex align-items-center justify-content-between list-group-item list-group-item-action">
        {label}
        {
          value?.url ? <span className={"text-success"}>
                            <TickIcon />
                        </span>: null
        }
      </button>
      {
        value?.url ? <div className="text-right">
          <a href={value.url} target={"_blank"} download>Download submitted form</a>
        </div> : null
      }
      <Modal title={label} size={'lg'} confirmLoading={loading}
             visible={visible} disabled={!canSubmit}
             okText={formType ? result ? 'Done' : 'Submit' : undefined}
             onClose={toggle}
             onCancel={formType ? toggle : undefined}
             onSubmit={formType ? onSubmit : undefined}>
        {
          !formType ? <>
            <div className="text-center">
              <p className={"lead"}>Are you a US citizen or resident alien? </p>
              <>
                <button onClick={()=>{
                  setFormType('w9')

                }} className="btn btn-outline-primary mr-2">Yes</button>
                <button onClick={()=>setFormType('w8')} className="btn btn-outline-danger">NO</button>
              </>
            </div>
          </> : <button className={"btn p-0 mb-2"} onClick={()=>setFormType(null)}><FiArrowLeft /> Go back</button>
        }
        {
          formType === "w9" ?  <>
            {
              result ? <>
                    <p>Download and review your completed W-9 Form. Click Done to send the form to us. If you want change the content, <span className={"text-primary pointer-cursor"} onClick={()=>setResult(null)}>click here</span> to fill it again</p>
                    <p>
                      <a href={result.url} target={"_blank"} download>Download W-9 Form</a>
                    </p>
                  </> :<>
                  <p className={"lead"}>W9 form</p>
                  <RenderW9Form value={data} onChange={setData} /></>
            }              </> : null
        }
        {
          formType === "w8" ? <>
            {
              result ? <>
                    <p>Download and review your completed W-8 Form. Click Done to send the form to us. If you want change the content, <span className={"text-primary pointer-cursor"} onClick={()=>setResult(null)}>click here</span> to fill it again</p>
                    <p>
                      <a href={result.url} target={"_blank"} download>Download W-8 Form</a>
                    </p>
                  </> : <>
                  <p className={"lead text-decoration-underline"}>W8 form</p>
                  <RenderW8Form value={data} onChange={setData} />
              </>
          }</> : null
        }

          </Modal>
    </div>
  </>
}
